
<div class="container">
    <div class="row justify-content-center">
        <div class="box d-none d-lg-block col-sm-12 col-lg-7">
            <div class="box__cont box__cont--image">  
            </div>
        </div>
        <div class="box col-12 col-md-8 col-lg-5">
            <div class="box__cont">
                <div class="box__title">
                    <h1>Create New Password</h1>
                    <h2>to reaccess your account </h2>
                    <span class="box__instruction">Your password should contain a minimum of 12 and maximum of 15 characters, 1 upper case, 1 lower case, 1 number, and 1 special character</span>
                </div>
                <div class="box__form">
                    <div class="col-12 box__field">
                        <atram-textbox [parentFormGroup]="searchFormGroup"
                                        type="password"
                                        controlName="word"
                                        label="New Password"
                                        [isError]="(!searchFormGroup.get('word')?.valid && searchFormGroup.get('word')?.touched) || (searchFormGroup.get('word')?.value !== searchFormGroup.get('confirmWord')?.value)"
                                        placeholder="New Password"  
                                        [showEyeButton]="true"  
                                        [isRequired]="true">
                        </atram-textbox>
                        <h3 class="box__error-notif" *ngIf="(searchFormGroup.get('word')?.value !== searchFormGroup.get('confirmWord')?.value)">Your inputs did not match. Please try again.</h3>
                        
                    </div>
                    <div class="col-12 box__field">
                        <atram-textbox [parentFormGroup]="searchFormGroup"
                                        type="password"
                                        controlName="confirmWord"
                                        label="Confirm Password"
                                        placeholder="Confirm Password"
                                        [isError]="(!searchFormGroup.get('confirmWord')?.valid && searchFormGroup.get('confirmWord')?.touched) || (searchFormGroup.get('word')?.value !== searchFormGroup.get('confirmWord')?.value)"
                                        [showEyeButton]="true"
                                        [isRequired]="true">
                        </atram-textbox>
                        <h3 class="box__error-notif" *ngIf="(searchFormGroup.get('word')?.value !== searchFormGroup.get('confirmWord')?.value)">Your inputs did not match. Please try again.</h3>
                    </div>
                    <div class="row justify-content-center">
                        <div class="d-sm-none col-12">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>  
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Back to Sign In"
                                            componentClass="btn-submit"
                                            (on-click)="goToSignIn()">
                                        </atram-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-sm-block col-12">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Back to Sign In"
                                            componentClass="btn-submit"
                                            (on-click)="goToSignIn()">
                                        </atram-button>
                                    </div>
                                      <div class="col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>